import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GcMultiselectService } from '../service/gc-multiselect.service';

@Component({
  selector: 'app-gc-multiselect',
  templateUrl: './gc-multiselect.component.html',
  providers: [
    GcMultiselectService
  ]
})
export class GcMultiselectComponent implements OnInit {
  @Output() gcsSelected = new EventEmitter<string[]>();
  gcs: {name: string, checked: boolean}[] = [];
  multiselect = {open: false};

  constructor(private gcMultiselectService: GcMultiselectService) {
  }

  ngOnInit() {
    this.getGCs();
  }

  hasFilter() {
    return this.gcs.filter(gc => gc.checked).length > 0;
  }

  search(){
    this.multiselect = {open: false};
    this.gcsSelected.emit(this.gcs.filter(gc => gc.checked).map(gc => gc.name));
  }

  clearFields(){
    this.multiselect = {open: false};
    this.gcs = this.gcs.map(gc => ({name: gc.name, checked: false}));
    this.gcsSelected.emit(this.gcs.map(gc => gc.name));
  }

  getGCs() {
    this.gcMultiselectService.getGCPadrao()
      .subscribe(result => {
        this.gcs = result.Result.map(gc => ({name: gc.Nome, checked: false}));
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpit/gc-multiselect/component/gc-multiselect.component.ts